//广告组状态
const adGroupStatus = [
  { value: -1, label: "全部状态" },
  { value: "1", label: "计划已暂停" },
  { value: "3", label: "计划超预算" },
  { value: "6", label: "余额不足" },
  { value: "10", label: "已删除" },
  { value: "11", label: "审核中" },
  { value: "12", label: "审核未通过" },
  { value: "14", label: "已结束" },
  { value: "15", label: "已暂停" },
  { value: "17", label: "组超预算" },
  { value: "19", label: "未达投放时间" },
  { value: "20", label: "有效" },
];

const filterStatus = [
  { value: "STATUS_UNKNOWN", label: "未知状态" },
  { value: "STATUS_PENDING", label: "审核中" },
  { value: "STATUS_DENIED", label: "审核不通过" },
  { value: "STATUS_FROZEN", label: "冻结" },
  { value: "STATUS_SUSPEND", label: "暂停中" },
  { value: "STATUS_READY", label: "未到投放时间" },
  { value: "STATUS_ACTIVE", label: "投放中" },
  { value: "STATUS_STOP", label: "投放结束" },
  { value: "STATUS_PREPARE", label: "准备中" },
  { value: "STATUS_DELETED", label: "已删除" },
  { value: "STATUS_ACTIVE_ACCOUNT_FROZEN", label: "广告被暂停（账户资金被冻结）" },
  { value: "STATUS_ACTIVE_ACCOUNT_EMPTY", label: "广告被暂停（账户余额不足）" },
  { value: "STATUS_ACTIVE_ACCOUNT_LIMIT", label: "广告被暂停（账户达日限额）" },
  { value: "STATUS_ACTIVE_CAMPAIGN_LIMIT", label: "广告被暂停（推广计划达日限额）" },
  { value: "STATUS_ACTIVE_CAMPAIGN_SUSPEND", label: "广告被暂停（推广计划暂停）" },
  { value: "STATUS_ACTIVE_AD_LIMIT", label: "广告被暂停（广告达日限额）" },
  { value: "STATUS_PART_READY", label: "部分待投放" },
  { value: "STATUS_PART_ACTIVE", label: "部分投放中" },
  { value: "STATUS_TRACKING_URL_SUSPEND", label: "广告被暂停（第三方监测链接未通过）" },
];

const placeList = [
  { value: "1", label: "优选广告位" },
  { value: "5", label: "联盟广告" },
  { value: "6", label: "上下滑大屏广告" },
  { value: "24", label: "激励视频" },
];

export default {
  adGroupStatus,
  placeList,
  filterStatus,
};
